import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-43aef786"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "json-code-container"
};
const _hoisted_2 = {
  class: "btn-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
    modelValue: $data.inputJson,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.inputJson = $event),
    placeholder: "请输入 JSON 数据",
    class: "json-input",
    type: "textarea",
    rows: "10"
  }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
    type: "primary",
    onClick: $options.formatJson
  }, {
    default: _withCtx(() => [_createTextVNode("格式化 JSON")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    type: "success",
    onClick: $options.copyToClipboard,
    disabled: !$data.outputJson
  }, {
    default: _withCtx(() => [_createTextVNode("复制结果")]),
    _: 1
  }, 8, ["onClick", "disabled"])]), _createVNode(_component_el_input, {
    modelValue: $data.outputJson,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.outputJson = $event),
    placeholder: "格式化后的结果将显示在这里",
    class: "json-output",
    type: "textarea",
    rows: "10",
    readonly: ""
  }, null, 8, ["modelValue"])]);
}